<template>
    <div class="main-box mh-a">
        <iristar-dividing> {{ $t("title.title3") }} </iristar-dividing>
        <div class="iristar-pro-item">
            <div class="flex a-i-c">
                <el-image
                    class="border-r m-details"
                    :src="productDetial.img"
                    fit="cover"
                ></el-image>
                <div class="p20 flex1">
                    <h4 class="fs24">{{ productDetial.type }}</h4>
                    <h4 class="lh30 fs18 c-g-d">
                        {{ productDetial.name }}
                    </h4>
                    <div>
                        <el-tag
                            class="m10"
                            size="small"
                            type="info"
                            v-for="(tag, idx) in productDetial.point"
                            :key="`${idx}_tag`"
                            >{{ tag }}</el-tag
                        >
                    </div>
                    <p class="fs14 text-indent lh30 c-g-d text-justify">
                        {{ productDetial.desc }}
                    </p>
                    <el-table :data="productDetial.param" class="w-total">
                        <el-table-column prop="key"> </el-table-column>
                        <el-table-column prop="val" v-if="productDetial.label!=1"> 
                            <template slot-scope="scope">
                                <div v-html="scope.row.val"></div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IristarDividing from "@/components/IristarDividing";
import ProductList from "@/assets/product/productList";
import ProductListEn from "@/assets/product/productList-en";
export default {
    name: "ProductDetial",
    computed: {
        productDetial() {
            let list =
                this.$store.state.language === "zh"
                    ? ProductList
                    : ProductListEn;
            let detialArr = list.filter((item) => {
                return item.type == this.$route.params.index;
            });
            return detialArr[0];
        },
    },
    components: {
        IristarDividing,
    },
};
</script>

<style lang="less">
</style>